export const BASE_PATH = window.location.origin.search('localhost') !== -1
  // ? 'http://fst-backend.localhost:8000/'
  ? 'http://localhost:8011'
  : `${window.location.origin}`

const requestHeaders: HeadersInit = new Headers()
requestHeaders.set('Accept', 'application/json')
requestHeaders.set('Content-Type', 'application/json')

const devEnv = {
  restBase: BASE_PATH,
  fetchHeaders: requestHeaders,
}

const stageEnv = {
  ...devEnv,
}

const prodEnv = {
  ...devEnv,
}

type Env = typeof devEnv
  | typeof stageEnv
  | typeof prodEnv

const getEnvValues: () => Env = () => {
  switch (process.env.BUILD_ENV) {
    case 'production':
      return prodEnv
    case 'staging':
      return stageEnv
  }
  return devEnv
}

export const isDebugEnv: boolean = process.env.BUILD_ENV !== undefined
  ? process.env.BUILD_ENV === 'development'
  : process.env.NODE_ENV === 'development'

export default getEnvValues()
